import React, { useRef } from "react";
import Button, { ButtonProps } from "@material-ui/core/Button";


export function CustomButton<C extends React.ElementType>(
    props: ButtonProps<C, { component?: C }>
  ) {
    const { children, ...rest } = props;
    return <Button {...rest}>{children}</Button>;
  }